import { memo } from 'react';

import { CurrentVersionChip } from '~/components/AssetModalV2/components/CurrentVersionChip';

export type AssetVersionChipProps = {
  'data-testid'?: string;
  defaultVersionNumber: number | undefined;
  viewedVersionNumber: number;
  onClick: () => void;
};

export const AssetVersionChip = memo(
  ({ 'data-testid': dataTestId, defaultVersionNumber, viewedVersionNumber, onClick }: AssetVersionChipProps) => {
    const isViewingDefaultVersion = viewedVersionNumber === defaultVersionNumber;

    return (
      <button
        className="inline-flex shrink-0 cursor-pointer appearance-none border-0 bg-transparent p-0 leading-none transition-opacity hover:opacity-80"
        data-testid={dataTestId}
        onClick={onClick}
        type="button"
      >
        <CurrentVersionChip isHeadVersion={isViewingDefaultVersion} versionNumber={viewedVersionNumber} />
      </button>
    );
  },
);

AssetVersionChip.displayName = 'AssetVersionChip';
